import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import domain from "../../Services/DomainService";

export default function ReferAndEarn() {
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const jwt = localStorage.getItem("token");

    fetch(domain() + "affonso/embed-token", {
      method: "POST",
      headers: { Authorization: "JWT " + jwt },
    })
      .then(async (res) => {
        const json = await res.json();
        if (!res.ok) throw new Error(json.message || "Failed to load referral program");
        return json;
      })
      .then((json) => {
        if (!cancelled) setToken(json.token);
      })
      .catch((err) => {
        console.error("[ReferAndEarn token error]", err);
        if (!cancelled) setError(err.message);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div style={{ padding: "1.5rem 2.5rem", background: "var(--color-grey-50)" }}>
      <Box mb="1.5rem">
        <h1>Refer & Earn</h1>
        <p style={{ color: "#2563EB", margin: 0 }}>Share Kynzo with your network and earn commission on every referral.</p>
      </Box>

      {error && <p style={{ color: "#DC2626" }}>{error}</p>}

      {!error && !token && <p>Loading your referral dashboard...</p>}

      {token && (
        <iframe
          id="affonso-embed"
          title="Refer & Earn"
          src={`https://affonso.io/embed/referrals?token=${token}&theme=light&lang=en`}
          style={{ width: "100%", height: "1400px", border: "none" }}
          allow="clipboard-write"
        />
      )}
    </div>
  );
}
